// extracted by mini-css-extract-plugin
export default {"container":"RewardBlock_container__KMG8t","slideShine":"RewardBlock_slideShine__KnpqL","image":"RewardBlock_image__XLduv"};